import { memo, useCallback, useEffect, useState } from "react";
import type { FC } from "react";
import { useHeaderImages } from "../contexts/HeaderImagesContext";

interface HeaderImageProps {
	initialIndex: number;
}

export const HeaderImage: FC<HeaderImageProps> = memo(({ initialIndex }) => {
	const [index, setIndex] = useState(initialIndex);
	const [isTransitioning, setIsTransitioning] = useState(false);
	const [isFirstImage, setIsFirstImage] = useState(true);
	const { registerImage, unregisterImage, getNextAvailableImage, images } =
		useHeaderImages();

	// Registrujeme a odregistrujeme obrázek při změně indexu
	useEffect(() => {
		registerImage(index);
		return () => unregisterImage(index);
	}, [index, registerImage, unregisterImage]);

	const handleTransition = useCallback(() => {
		setIsTransitioning(true);
		setTimeout(() => {
			const nextIndex = getNextAvailableImage(index);
			setIndex(nextIndex);
			setIsTransitioning(false);
		}, 500);
	}, [index, getNextAvailableImage]);

	useEffect(() => {
		if (isFirstImage) {
			const timeout = setTimeout(
				() => {
					handleTransition();
					setIsFirstImage(false);
				},
				initialIndex * 3 * 1000,
			);
			return () => clearTimeout(timeout);
		}

		const intervalId = setInterval(handleTransition, 9000);
		return () => clearInterval(intervalId);
	}, [isFirstImage, initialIndex, handleTransition]);

	return (
		<div className="w-full h-full relative overflow-hidden">
			<div
				className={`absolute inset-0 transition-opacity duration-500 ease-in-out ${
					isTransitioning ? "opacity-0" : "opacity-100"
				}`}
			>
				<img
					src={images[index]}
					alt="Svatební fotka"
					className="w-full h-full object-cover"
				/>
			</div>
			<div className="absolute inset-0 shadow-[inset_0_-20px_20px_-10px_rgba(0,0,0,0.3)]" />
		</div>
	);
});
